import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { SelectorListItem } from '../../ui-components/zf-selector-list/zf-selector-list-type';

@Component({
  selector: 'shift-selector-modal',
  templateUrl: 'shift-selector-modal.html',
})
export class ShiftSelectorModal {
  public header = 'Select Shift';
  public activeIndex = 0;
  public items: SelectorListItem[][] = [[]];

  constructor(private navParams: NavParams, private modalCtrl: ModalController) {
    this.items = this.navParams.get('items');
    this.activeIndex = this.navParams.get('activeIndex');
  }

  public handleElementClick(index) {
    this.modalCtrl.dismiss(index);
  }
}
